"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import CustomFieldRendererOverride from "./custom_field_renderer_override";
import editorBudgetField from "./editor_budget_field";
import editorUploadField from "./editor_upload_field";
const whenDecidimAwesomeInitialized = (retryCount = 0) => {
  return new Promise((resolve, reject) => {
    var _a, _b, _c, _d, _e, _f;
    if (((_a = window.DecidimAwesome) == null ? void 0 : _a.CustomFieldsRenderer) && ((_b = window.DecidimAwesome) == null ? void 0 : _b.PrivateCustomFieldsRenderer) && (((_d = (_c = window.DecidimAwesome) == null ? void 0 : _c.CustomFieldsRenderer) == null ? void 0 : _d.$element) || ((_f = (_e = window.DecidimAwesome) == null ? void 0 : _e.PrivateCustomFieldsRenderer) == null ? void 0 : _f.$element))) {
      resolve();
    } else {
      if (retryCount > 10) {
        return reject("decidim-voca: DecidimAwesome is not initialized");
      }
      console.warn(
        "decidim-voca: DecidimAwesome is not initialized, retrying...."
      );
      setTimeout(() => {
        whenDecidimAwesomeInitialized(retryCount + 1).then(resolve);
      }, 64);
    }
  });
};
document.addEventListener("DOMContentLoaded", () => {
  editorBudgetField();
  editorUploadField();
  whenDecidimAwesomeInitialized().then(() => {
    window.DecidimAwesome.CustomFieldsRenderer = new CustomFieldRendererOverride(
      window.DecidimAwesome.CustomFieldsRenderer
    );
    window.DecidimAwesome.PrivateCustomFieldsRenderer = new CustomFieldRendererOverride(
      window.DecidimAwesome.PrivateCustomFieldsRenderer
    );
    const $public = $(".proposal_custom_field:first");
    const $private = $(
      ".proposal_custom_field.proposal_custom_field--private_body:first"
    );
    let $form = null;
    if ($public.length) {
      $form = window.DecidimAwesome.CustomFieldsRenderer.$element.closest("form");
    }
    if ($private.length && !$form) {
      $form = window.DecidimAwesome.PrivateCustomFieldsRenderer.$element.closest(
        "form"
      );
    }
    if ($form) {
      $form.off("submit");
      $form.on("submit", (evt) => __async(this, null, function* () {
        evt.preventDefault();
        if (evt.target.checkValidity()) {
          if ($public.length) {
            yield window.DecidimAwesome.CustomFieldsRenderer.storeData();
          }
          if ($private.length) {
            yield window.DecidimAwesome.PrivateCustomFieldsRenderer.storeData();
          }
          evt.target.submit();
        } else {
          evt.target.reportValidity();
        }
      }));
    }
  }).catch(() => {
    console.warn(
      "decidim-voca: DecidimAwesome is not initialized, skipping override"
    );
  });
});
